import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SyncService } from 'src/app/_services/sync.service';

@Component({
  selector: 'log-popup',
  templateUrl: './log-popup.component.html',
  styleUrls: ['./log-popup.component.css'],
})
export class LogPopupComponent implements OnInit {
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  message: any;
  maxLength = 200;
  id: any;
  canDownload: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public syncService: SyncService
  ) {}

  ngOnInit() {
    if (this.message && this.message.length > this.maxLength) {
      this.canDownload = true;
    }
  }

  save() {
    this.close.emit();
    this.activeModal.close();
  }

  cancel() {
    this.activeModal.dismiss();
  }

  download() {
    this.syncService.getJsonById(this.id).subscribe((res) => {
      const contentDispositionHeader = res.headers.get('Content-Disposition');
      const fileName = contentDispositionHeader
        .split(';')[1]
        .split('=')[1]
        .trim()
        .replace(/"/g, ''); // Elimina las comillas
      this.convertToTxt(JSON.stringify(res.body, null, 2), fileName);
    });
  }

  convertToTxt(data: string, fileName: string) {
    const blob = new Blob([data], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName + '.txt'; // Establece el nombre del archivo con el nombre proporcionado

    document.body.appendChild(link);
    link.click();

    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }
}
